export default () => ({
    draft: '',
    saved: '',
    pending: false,
    observer: null,

    init() {
        this.saved = this.draft = this.$el.dataset.savedLabel
        this.observer = new MutationObserver(() => this.reconcile())
        this.observer.observe(this.$el, { attributes: true, attributeFilter: ['data-saved-label'] })
    },

    destroy() {
        this.observer?.disconnect()
    },

    reconcile() {
        const previous = this.saved
        this.saved = this.$el.dataset.savedLabel
        if (!this.pending && (this.draft === previous || document.activeElement !== this.$el)) {
            this.draft = this.saved
        }
    },

    cancel() {
        this.draft = this.saved
        this.$el.setCustomValidity('')
    },

    async save() {
        if (this.pending || this.draft === this.saved) return
        this.draft = this.draft.trim()
        if (this.draft === this.saved) return
        this.$el.value = this.draft
        if (!this.$el.reportValidity()) return

        // Native change and blur can both fire for Enter; claim this save first.
        this.pending = true
        try {
            await this.$wire.renameQuickFilter(this.$el.dataset.quickFilterName, this.draft)
        } catch {
            this.draft = this.saved
            this.$el.setCustomValidity(this.$el.dataset.saveError)
        } finally {
            this.pending = false
            this.reconcile()
            if (this.$el.validity.customError) this.$el.reportValidity()
        }
    },
})
